import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import TabelasCopariticipacao from '../views/TabelaCoparticipacao.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',    
    component: Home,    
  },
   {
    path: '/:tipopessoa',
    name: 'Home',
    component: Home,
    props: true
  },
  {
    path: '/tabelas',
    name: 'Tabelas',
    component: TabelasCopariticipacao,
    props: true
  }
]

const router = new VueRouter({
  mode: 'history',
  routes
})

export default router
